<!--
  输入支付密码
  Lovi 2020-02-21
-->
<template>
  <van-popup
    v-model="popupFlag"
    class="popup-payPsd"
    position="bottom"
    :class="type == 1 ? 'popup-header' : ''"
    :overlay-class="type == 1 ? 'overlay-header' : ''"
    :close-on-click-overlay="type == 1 ? false : true"
    get-container="body"
  >
    <div class="title">
      <span @click="clickCanel">{{ $t("common.cancel") }}</span>
      <span class="text-orange" @click="forgetPayPsd">
        {{ $t("payPsd.forgotPayPsd") }}
      </span>
    </div>
    <div class="pop-content">
      <h3 v-if="data.title">{{ data.title }}</h3>
      <h5 v-if="data.money">{{ data.money }}P</h5>
      <van-password-input
        :gutter="10"
        :value="payPsd"
        :focused="true"
        @focus="showKeyboard = true"
      />
      <p class="text-orange" v-if="data.tips">{{ data.tips }}</p>
      <!-- 数字键盘 -->
      <van-number-keyboard
        :show="true"
        @input="onInput"
        @delete="onDelete"
        @blur="showKeyboard = false"
      />
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    payPsdFlag: {
      type: Boolean,
      default: false
    },
    type: {
      //1 付款码
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function() {
        return {
          title: "",
          money: "",
          tips: ""
        };
      }
    }
  },
  components: {},
  data() {
    return {
      popupFlag: false,
      showKeyboard: false, //数字键盘开关
      payPsd: "", //支付密码
      sixFlag: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    clickCanel() {
      // 取消
      if (this.type) {
        this._back();
      } else {
        this.popupFlag = false;
      }
    },
    forgetPayPsd() {
      // 忘记支付密码
      this.$router.push({
        path: "/forgetPayPsd"
      });
    },
    onInput(key) {
      // 监听按键内容
      let vm = this;
      vm.payPsd = (vm.payPsd + key).slice(0, 6);
      if ((vm.payPsd + "").length == 6) {
        if (!vm.sixFlag) {
          vm.sixFlag = true;
          vm.validatePayPassword();
        }
      }
    },
    validatePayPassword() {
      // 验证支付密码
      let vm = this;
      vm.$post(
        "/app/user/validatePayPassword",
        { pay_password: vm.payPsd },
        { alert: true }
      ).then(res => {
        console.log("validatePayPassword", res);
        vm.sixFlag = false;
        if (res.code == 0) {
          vm.showKeyboard = false;
          vm.$emit("getPayPsd", vm.payPsd);
          vm.popupFlag = false;
        } else {
          vm.payPsd = "";
          vm.$toast(res.msg);
        }
      });
    },
    onDelete() {
      // 删除
      this.payPsd = this.payPsd.slice(0, this.payPsd.length - 1);
    }
  },
  watch: {
    payPsdFlag(bol) {
      this.popupFlag = bol;
    },
    popupFlag(bol) {
      this.$emit("update:payPsdFlag", bol);
      this.payPsd = "";
    }
  }
};
</script>

<style lang="less" scoped>
.popup-payPsd {
  .title {
    height: 40px;
    padding: 0 15px;
    font-size: 14px;
    color: #9b9b9b;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1.1px solid #eee;
  }

  .pop-content {
    text-align: center;
    min-height: 240px;
    line-height: 1;
    padding-top: 8px;
    h3 {
      margin-top: 5px;
      font-size: 16px;
      font-weight: 500;
    }
    h5 {
      margin-top: 5px;
      font-size: 30px;
    }

    /deep/.van-password-input {
      margin: 10px 75px;
      margin-top: 0;
      .van-password-input__security {
        height: 40px;
      }
      .van-hairline--surround::after,
      .van-hairline--left::after {
        border-width: 0;
        border-radius: 0;
      }
      ul li {
        border-bottom: 2px solid #4a4a4a;
      }
    }
    /deep/.van-number-keyboard {
      position: inherit;
      margin-top: 20px;
    }
  }
}
</style>
